import React from 'react';
import { NavBarItemProps } from './NavBarItemProps';

const NavCustom: React.FC<NavBarItemProps> = (props) => {
    return props.item.component?.(props) ?? null;
}

export default NavCustom;